import axios from "axios";
import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ActivePhlebo = () => {
  const [phleboList, setPhleboList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [contactFilter, setContactFilter] = useState("");

  const [selectedClinic, setSelectedClinic] = useState("");
  const [selectedDate, setSelectedDate] = useState("");


  const [eclinicList, setEclinicList] = useState([]);

  const location = useLocation();
  const incomingStatus = location.state?.status;

 const fetchPhleboData = async (customParams = {}) => {
  try {
    setLoading(true);

      const params = {
        status: incomingStatus ? 0 : 1,
      };

    // Only add filter params if they have actual values (not empty strings)
    const phleboNameValue = customParams.phleboName !== undefined ? customParams.phleboName : searchTerm;
    const mobileValue = customParams.mobile !== undefined ? customParams.mobile : contactFilter;
    const eclinicValue = customParams.eclinic !== undefined ? customParams.eclinic : selectedClinic;
    const dateValue = customParams.deactivationDate !== undefined ? customParams.deactivationDate : selectedDate;

    if (phleboNameValue && phleboNameValue.trim() !== "") {
      params.phleboName = phleboNameValue.trim();
    }
    if (mobileValue && mobileValue.trim() !== "") {
      params.mobile = mobileValue.trim();
    }
    if (eclinicValue && eclinicValue.trim() !== "") {
      params.eclinic = eclinicValue.trim();
    }
    if (dateValue && dateValue.trim() !== "") {
      params.deactivationDate = dateValue.trim(); 
    }

    const response = await axios.get(
      `${process.env.REACT_APP_PHLEBO_BASEURL}phlebotomist-status`,
      {
        params,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data?.content || [];
    setPhleboList(data);

  } catch (error) {
    console.error("Error fetching phlebo data", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchEclinicList();
  }, []);

const fetchEclinicList = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_PHLEBO_BASEURL}eclinicList`);
    const data = response.data?.data || [];
    const formatted = data.map((clinic) => ({
      label: clinic.name,
      value: clinic.code,
    }));
    setEclinicList(formatted);
  } catch (error) {
    console.error("Failed to fetch eClinic list:", error);
  }
};


  useEffect(() => {
    fetchPhleboData();
  }, []);

  const statusConfig = {
    Ready: {
      color: "#ffffff",
      bgColor: "#22c55e"
    },
    "On Visit": {
      color: "#ffffff",
      bgColor: "#f59e0b"
    },
    Break: {
      color: "#ffffff",
      bgColor: "#f97316"
    },
    Busy: {
      color: "#ffffff",
      bgColor: "#3b82f6"
    }
  };

  const containerStyle = {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    padding: "24px"
  };

  const maxWidthStyle = {
    maxWidth: "1280px",
    margin: "0 auto"
  };

  const headerStyle = {
    marginBottom: "32px"
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "600",
    color: "#111827",
    marginBottom: "32px"
  };

  const filterGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: "16px",
    marginBottom: "32px"
  };

  const labelStyle = {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "8px"
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    outline: "none",
    fontSize: "14px",
    backgroundColor: "#ffffff"
  };

  const inputFocusStyle = {
    ...inputStyle,
    borderColor: "#3b82f6",
    boxShadow: "0 0 0 1px #3b82f6"
  };

  const searchContainerStyle = {
    position: "relative"
  };

  const searchIconStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#3b82f6",
    width: "16px",
    height: "16px"
  };

  const selectContainerStyle = {
    position: "relative"
  };

  const selectStyle = {
    ...inputStyle,
    appearance: "none",
    paddingRight: "32px"
  };

  const selectArrowStyle = {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none"
  };

  const calendarContainerStyle = {
    position: "relative"
  };

  const calendarIconStyle = {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#9ca3af",
    width: "16px",
    height: "16px"
  };

  const cardsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "24px"
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    padding: "16px"
  };

  const cardContentStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px"
  };

  const avatarStyle = {
    flexShrink: 0
  };

  const avatarCircleStyle = {
    width: "48px",
    height: "48px",
    backgroundColor: "#e5e7eb",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const avatarIconStyle = {
    width: "24px",
    height: "24px",
    color: "#9ca3af"
  };

  const contentStyle = {
    flex: 1,
    minWidth: 0
  };

  const headerRowStyle = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: "12px",

  };

  const nameStyle = {
    fontSize: "16px",
    fontWeight: "700",
    color: "#004171"
  };

  const phoneStyle = {
    fontSize: "14px",
    color: "#004171"
  };

  const rightHeaderStyle = {
    textAlign: "right"
  };

  const activeIndicatorStyle = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginBottom: "4px"
  };

  const activeDotStyle = {
    width: "8px",
    height: "8px",
    backgroundColor: "#22c55e",
    borderRadius: "50%"
  };

  const activeTextStyle = {
    fontSize: "14px",
    color: "#16a34a"
  };

  const typeStyle = {
    fontSize: "12px",
    color: "#6b7280"
  };

  const detailsStyle = {
    marginBottom: "16px"
  };

  const detailRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px"
  };

  const detailLabelStyle = {
    fontSize: "14px",
    color: "#6b7280"
  };

  const detailValueStyle = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#111827"
  };

  const bottomRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "16px"
  };

  const loadingContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "384px"
  };

  const spinnerStyle = {
    width: "32px",
    height: "32px",
    border: "2px solid #e5e7eb",
    borderTop: "2px solid #3b82f6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite"
  };

  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={maxWidthStyle}>
          <div style={loadingContainerStyle}>
            <div style={spinnerStyle}></div>
          </div>
        </div>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

const clearFilters = () => {
  // Clear all filter states
  setSearchTerm("");
  setContactFilter("");
  setSelectedClinic("");
  setSelectedDate("");

  // Immediately fetch data with cleared filters
  fetchPhleboData({
    phleboName: "",
    mobile: "",
    eclinic: "",
    deactivationDate: ""
  });
};

  return (
    <div style={containerStyle}>
      <div style={maxWidthStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <h1 style={titleStyle}>{incomingStatus ? "Inactive" : "Active"} Phlebotomist</h1>


          {/* Filter Bar */}
          <div style={filterGridStyle}>
            {/* Phlebo Name Search */}
            <div>
              <label style={labelStyle}>Phlebo Name</label>
              <div style={searchContainerStyle}>
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={inputStyle}
                />
                <svg style={searchIconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>


            <div>
              <label style={labelStyle}>Contact Number</label>
              <input
                type="text"
                placeholder="Type here"
                value={contactFilter}
                onChange={(e) => setContactFilter(e.target.value)}
                style={inputStyle}
              />
            </div>



            {/* Select eClinic */}
            <div>
              <label style={labelStyle}>Select eClinic</label>
              <div style={selectContainerStyle}>
                <select
                  value={selectedClinic}
                  onChange={(e) => setSelectedClinic(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">Select</option>
                  {eclinicList.map((clinic, idx) => (
                    <option key={idx} value={clinic.value}>
                      {clinic.label}
                    </option>
                  ))}
                </select>

                <div style={selectArrowStyle}>
                  <svg style={{ width: "16px", height: "16px", color: "#9ca3af" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </div>
              </div>
            </div>

  {/* Select Date */}
 <div>
  <label style={labelStyle}>Select Date</label>
  <div style={calendarContainerStyle}>
    <Calendar
      value={selectedDate ? new Date(selectedDate + 'T00:00:00') : null}
      onChange={(e) => {
        const date = e.value;
        if (date) {
          // Use local date methods to avoid timezone issues
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const formatted = `${year}-${month}-${day}`;
          setSelectedDate(formatted);
        } else {
          setSelectedDate("");
        }
      }}
      placeholder="Select"
      showIcon
      dateFormat="yy-mm-dd"
      style={{ width: "100%" }}
    />
  </div>
</div>


            {/* Search Button */}
            <div style={{ display: "flex", alignItems: "flex-end", gap: "8px" }}>
              <button
                onClick={fetchPhleboData}
                style={{
                  backgroundColor: "#16a34a",
                  color: "white",
                  padding: "0.5rem 1rem",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                }}
              >
                Search
              </button>

              <button
                onClick={clearFilters}
                style={{
                  backgroundColor: "#e5e7eb",
                  color: "#374151",
                  padding: "0.5rem 1rem",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  cursor: "pointer"
                }}
              >
                Clear
              </button>
            </div>
          </div>


        </div>

        {/* Phlebotomist Cards Grid */}
        {phleboList.length > 0 ? (
        <div style={cardsGridStyle}>
          {phleboList.map((phlebo, idx) => {
            const status = phlebo.status || "Ready";

              return (
                <div key={idx} style={cardStyle}>
                  <div style={cardContentStyle}>
                    {/* Avatar */}
                    <div style={avatarStyle}>
                      <div style={avatarCircleStyle}>
                        <svg style={avatarIconStyle} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </div>

                    {/* Content */}
                    <div style={contentStyle}>
                      <div style={headerRowStyle}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <span style={nameStyle}>
                            {phlebo.userName}
                          </span>
                          <span style={phoneStyle}>{phlebo.mobile}</span>
                        </div>

                        <div style={rightHeaderStyle}>
                          <div style={activeIndicatorStyle}>
                            <div
                              style={{
                                ...activeDotStyle,
                                backgroundColor: incomingStatus ? "#ef4444" : "#22c55e", // red or green
                              }}
                            ></div>
                            <span
                              style={{
                                ...activeTextStyle,
                                color: incomingStatus ? "#dc2626" : "#16a34a",
                              }}
                            >
                              {incomingStatus ? "Inactive" : "Active"}
                            </span>
                          </div>
                          <p style={typeStyle}>{phlebo.smtype}</p>
                        </div>

                      </div>

                      <div style={detailsStyle}>
                        <div style={detailRowStyle}>
                          <span style={detailLabelStyle}>Phlebo Id:</span>
                          <span style={detailValueStyle}>{phlebo.userId}</span>
                        </div>

                        <div style={detailRowStyle}>
                          <span style={detailLabelStyle}>Assigned Location:</span>
                          <span style={detailValueStyle}>{phlebo.locationAddress}</span>
                        </div>
                      </div>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
        ) : (
  <div style={{ textAlign: "center", fontSize: "16px", color: "#6b7280", marginTop: "40px" }}>
    No data found
  </div>
)}


      </div>
    </div>
  );
};

export default ActivePhlebo;